'use client'

import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

import { useProductBrand } from '@/providers/product-brand-provider'
import { SelfAuthForm } from '@/components/auth/self-auth-form'
import { storeOnboardingReturnPath } from '@/lib/onboarding-return-path'
import { safeRedirectPath as sanitizeRedirect } from '@/lib/safe-redirect'

export function AuthEntryContent() {
  const brand = useProductBrand()
  const searchParams = useSearchParams()
  const redirectPath = sanitizeRedirect(searchParams.get('redirect_url')) || (brand.product === 'toolfare' ? '/connect/start' : '/')

  useEffect(() => {
    storeOnboardingReturnPath(redirectPath)
  }, [redirectPath])

  return <SelfAuthForm />
}
